class TextAnimation extends HTMLElement {
  constructor() {
    super();
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const items = this.querySelectorAll('.text_with_icon--item');
            items.forEach(item => item.classList.add('visible'));
            this.observer.disconnect();
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      }
    );
  }

  connectedCallback() {
    if (this.classList.contains('animate')) {
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }
}

customElements.define('text-animation', TextAnimation);
